import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function CancellationRefundPolicy() {
  return (
    <main className="min-h-[70vh] bg-[#FFF9F0] px-4 pb-16 pt-[132px] sm:px-8">
      <SEO
        title="Cancellation & Refund Policy"
        description="How to request an order cancellation or refund from Nityavastra."
      />
      <div className="mx-auto max-w-4xl">
        <header className="rounded-3xl bg-[#7C1F30] p-7 text-white sm:p-10">
          <p className="text-xs uppercase tracking-[0.25em] text-[#E7C78A]">Order help</p>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl">
            Cancellation &amp; Refund Policy
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-white/85">
            Please contact us promptly if you need to change or cancel an order.
            Keep the order number handy so we can review its status.
          </p>
        </header>

        <div className="mt-6 space-y-4 text-sm leading-7 text-[#5D4B3E]">
          <section className="rounded-2xl border border-[#E5D5BF] bg-white p-6 sm:p-8">
            <h2 className="font-serif text-2xl text-[#2A1508]">Before dispatch</h2>
            <p className="mt-3">
              Send a cancellation request through the <Link to="/contact" className="text-[#7C1F30] underline">Contact form</Link> or
              email <a href="mailto:hello@nityavastra.com" className="text-[#7C1F30] underline">hello@nityavastra.com</a>.
              We will check whether the order can still be stopped and confirm the outcome.
              If a prepaid order is cancelled, its eligible refund is initiated through the
              original payment provider.
            </p>
          </section>

          <section className="rounded-2xl border border-[#E5D5BF] bg-white p-6 sm:p-8">
            <h2 className="font-serif text-2xl text-[#2A1508]">After dispatch or delivery</h2>
            <p className="mt-3">
              An order already with the courier may not be stoppable. Once delivered,
              check our <Link to="/pages/return-policy" className="text-[#7C1F30] underline">Return &amp; Exchange Policy</Link>.
              Eligible returns can be requested within seven days of delivery.
              Sign in and open your order to submit a return or exchange request,
              or contact support for help. Exclusions and product-condition requirements
              are explained in that policy.
            </p>
          </section>

          <section className="rounded-2xl border border-[#E5D5BF] bg-white p-6 sm:p-8">
            <h2 className="font-serif text-2xl text-[#2A1508]">How refunds are handled</h2>
            <p className="mt-3">
              Approved prepaid refunds are initiated through the payment provider,
              normally to the original payment method. For an approved cash on delivery
              return that has already been paid for, our team will arrange a manual
              refund and request only the details needed to make that payment securely.
              The time for funds to appear can also depend on the payment provider or bank.
              We will share the refund status or reference when available.
            </p>
          </section>

          <section className="rounded-2xl border border-[#E5D5BF] bg-white p-6 sm:p-8">
            <h2 className="font-serif text-2xl text-[#2A1508]">Need help?</h2>
            <p className="mt-3">
              Quote your order number when contacting <Link to="/contact" className="text-[#7C1F30] underline">Customer Support</Link>.
              If a concern remains unresolved, our <Link to="/grievance-redressal" className="text-[#7C1F30] underline">Grievance Redressal</Link> page
              gives the officer's contact details. Nothing on this page limits your
              rights under applicable consumer law.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
